import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/ESPMarketOutlookHero-bg.webp";
import ArticleImg        from "../../asset/images/news/news-5.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .esp { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .esp-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden; 
  }
  .esp-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .esp-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .esp-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .esp-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 575px;
  }
  .esp-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .esp-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .esp-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .esp-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .esp-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .esp-bc-item:hover { color: #EB2019; }
  .esp-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .esp-bc-sep img { width: 24px; height: 24px; display: block; }
  .esp-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .esp-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .esp-main-section { padding: 80px 0 120px 0; }
  .esp-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .esp-article { flex: 1; min-width: 0; }

  .esp-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .esp-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .esp-meta-item:last-child { border-right: none; padding-right: 0; }
  .esp-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .esp-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .esp-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .esp-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .esp-article-body p { margin-bottom: 15px; }
  .esp-article-body p:last-child { margin-bottom: 0; }

  /* Bold headings */
  .esp-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 30px 0 15px 0; line-height: 160%; display: block;
  }

  /* Numbered sub-heading */
  .esp-h3 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 20px 0 8px 0; line-height: 160%; display: block;
  }

  /* Numbered list (ol) */
  .esp-article-body ol {
    list-style: none; margin: 0 0 15px 0; padding: 0;
    display: flex; flex-direction: column; gap: 10px;
    counter-reset: esp-counter;
  }
  .esp-article-body ol li {
    display: flex; align-items: flex-start; gap: 8px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; counter-increment: esp-counter;
  }
  .esp-article-body ol li::before {
    content: counter(esp-counter) '.';
    font-weight: 400; color: #202020;
    flex-shrink: 0; min-width: 20px;
  }
  .esp-article-body ol li > span { flex: 1; }

  /* Bullet list (ul) */
  .esp-article-body ul {
    list-style: none; margin: 0 0 15px 0; padding: 0;
    display: flex; flex-direction: column; gap: 8px;
  }
  .esp-article-body ul li {
    display: flex; align-items: flex-start; gap: 10px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .esp-article-body ul li::before {
    content: '•'; color: #202020;
    font-size: 16px; line-height: 160%; flex-shrink: 0;
  }
  .esp-article-body ul li > span { flex: 1; }

  .esp-article-body strong { font-weight: 600; color: #202020; }

  .esp-red-link { color: #EB2019; text-decoration: underline; }
  .esp-red-link:hover { opacity: 0.8; }

  /* ══ BOTTOM ROW ══ */
  .esp-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .esp-bottom-nav { display: flex; align-items: center; gap: 30px; }
  .esp-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .esp-nav-btn:hover { color: #EB2019; }
  .esp-nav-btn img { width: 40px; height: 40px; display: block; }

  .esp-share-icons { display: flex; align-items: center; gap: 20px; }
  .esp-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .esp-share-icon:hover { opacity: 0.85; }
  .esp-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .esp-sidebar { flex: 0 0 475px; }
  .esp-sidebar-block { margin-bottom: 60px; }
  .esp-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .esp-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .esp-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .esp-recent-item:hover .esp-recent-title { color: #EB2019; }
  .esp-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .esp-recent-body { flex: 1; min-width: 0; }
  .esp-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .esp-social-icons { display: flex; align-items: center; gap: 30px; }
  .esp-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .esp-social-icon:hover { opacity: 0.8; }
  .esp-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .esp-hero             { height: 350px; }
    .esp-hero-content     { padding: 0 32px; }
    .esp-hero-title       { font-size: 30px; }
    .esp-hero-divider     { width: 100%; max-width: 479px; }
    .esp-breadcrumb       { padding: 24px 0 0 0; }
    .esp-breadcrumb-inner { padding: 0 32px; }
    .esp-inner            { padding: 0 32px; }
    .esp-main-section     { padding: 48px 0 60px 0; }
    .esp-main-row         { flex-direction: column; gap: 48px; }
    .esp-sidebar          { flex: none; width: 100%; }
    .esp-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .esp-hero             { height: 360px; }
    .esp-hero-content     { padding: 0 16px; }
    .esp-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .esp-hero-divider     { width: 100%; }
    .esp-hero-subtitle    { font-size: 14px; }
    .esp-breadcrumb       { padding: 30px 0 0 0; }
    .esp-breadcrumb-inner { padding: 0 16px; }
    .esp-bc-item          { font-size: 14px; gap: 14px; }
    .esp-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .esp-bc-sep img       { width: 22px; height: 22px; }
    .esp-inner            { padding: 0 16px; }
    .esp-main-section     { padding: 30px 0 60px 0; }
    .esp-main-row         { flex-direction: column; gap: 60px; }
    .esp-sidebar          { flex: none; width: 100%; }
    .esp-sidebar-title { font-size: 20px;}
    .esp-article-title    { font-size: 20px; margin-bottom: 15px; }
    .esp-article-body     { font-size: 14px; }
    .esp-meta-item        { font-size: 14px; }
    .esp-article-img      { margin: 25px 0 30px 0; height: 250px; }
    .esp-h2               { font-size: 16px; margin: 15px 0 15px 0; }
    .esp-h3               { font-size: 16px; margin: 15px 0 10px 0; }
    .esp-nav-btn img      { width: 24px; height: 24px; }
    .esp-nav-btn          { font-size: 14px; }
    .esp-share-icon img   { width: 34px; height: 34px; }
  }
`;

const recentPosts = [
  {
    img: RecentImg1,
    title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
    slug: "battery-formation-testing-enabling-rise-ev-energy-storage-manufacturing",
  },
  {
    img: RecentImg2,
    title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
    slug: "next-gen-esp-power-supplies-upgrades-sustainability-industrial-air-pollution-control",
  },
  {
    img: RecentImg3,
    title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
    slug: "green-hydrogen-power-electronics-ador-powertron-forefront-electrolyzer-rectifier-setups",
  },
  {
    img: RecentImg4,
    title: "Transformer Bushings: Types & Importance",
    slug: "transformer-bushings-types-importance",
  },
];

export default function ElectrostaticPrecipitatorMarketOutlook() {
  return (
    <div className="esp">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="esp-hero">
        <img className="esp-hero-bg" src={HeroBgImg} alt="ESP Market Outlook Hero" />
        <div className="esp-hero-overlay" />
        <div className="esp-hero-content">
          <h1 className="esp-hero-title">
            Electrostatic Precipitator Market Outlook 2025–2035: Trends &amp; Forecasts
          </h1>
          <hr className="esp-hero-divider" />
          <p className="esp-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="esp-breadcrumb" aria-label="Breadcrumb">
        <div className="esp-breadcrumb-inner">
          <a href="/" className="esp-bc-item">Home</a>
          <span className="esp-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="esp-bc-item">News &amp; Updates</a>
          <span className="esp-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="esp-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="esp-main-section">
        <div className="esp-inner">
          <div className="esp-main-row">

            {/* ── ARTICLE ── */}
            <article className="esp-article">

              {/* Meta bar */}
              <div className="esp-meta-bar">
                <span className="esp-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="esp-meta-item"><img src={CalendarIcon} alt="date" /> June 17, 2025</span>
                <span className="esp-meta-item"><img src={ClockIconImg} alt="time" /> 11:42 am</span>
                <span className="esp-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="esp-article-title">
                Electrostatic Precipitator Market Outlook 2025–2035: Trends &amp; Forecasts
              </h1>

              {/* Body */}
              <div className="esp-article-body">

                <p>As industries strive for cleaner operations, electrostatic precipitators (ESPs) are emerging as pivotal performers in emission control. They are the unacknowledged entities battling industrial air pollution.</p>

                <p>Let's discuss <strong>electrostatic precipitators</strong> , the pollution fighters and explore their significant role in industrial emission control.</p>

                <p>So, whether you are a leading manufacturer or an environmental engineer seeking the latest technology, these insights are for you. This blog explores the trends, innovations, and forecasts that will shape the international ESP market from 2025 to 2035—what drives demand and what's next.</p>

                <p>Let's break it down!</p>

                {/* Article image */}
                <img className="esp-article-img" src={ArticleImg} alt="Electrostatic Precipitator" />

                <span className="esp-h2">First things first!</span>

                <span className="esp-h2">So, what's driving the ESP Market forward?</span>

                <p>Nations around the globe are pulling emission norms, specifically in industries such as power generation, cement, steel, and chemicals, to achieve cleaner air. Parallel to this, electrostatic precipitators have become non-negotiable. As a result, enterprises are adopting cleaner technologies and encouraging companies to modernise their old dust collection methods.</p>

                <span className="esp-h2">Key Statistics and Projections</span>

                <ol>
                  <li><span>The global <strong>electrostatic precipitator</strong> market is projected to reach USD 12–15 billion by 2035.</span></li>
                  <li><span><strong>Asia-Pacific</strong>: Expected to exceed USD 7.1 billion by 2032</span></li>
                  <li><span><strong>North America</strong>: US market projected ~5% CAGR to 2032</span></li>
                  <li><span>The Asia-Pacific region continues to dominate, thanks to rapid industrial growth in China, India, and Southeast Asia.</span></li>
                  <li><span><strong>Wet ESPs</strong> are gaining popularity in applications where moisture-rich exhaust is prevalent.</span></li>
                </ol>

                <span className="esp-h2">What's Trending in ESP?</span>

                <span className="esp-h2">Let's understand!</span>

                <span className="esp-h3"> 1. Smart ESPs Are On the Rise</span>

                <p>Today's ESPs are smarter and are integrated with technologies like— real-time monitoring, AI, and systems that can predict maintenance before it starts costing you. These reduce technical hiccups and maintenance costs, contributing to overall increased efficiency.</p>

                <span className="esp-h3"> 2. Retrofitting Is the New Buying</span>

                <p>Retrofitting existing ESP systems rather than replacing them has become a more cost-effective option where budgets are tight, and sustainability is a key target. Retrofitting offers a high return on investment (ROI) and extends equipment life by a decade or more.</p>

                <span className="esp-h3"> 3. Carbon Capture Integration</span>

                <p>ESPs aren't just about dust; they are a key part of a bigger climate strategy and pre-treatment systems for flue gas. ESPs efficiently remove fine particulates before the CO2 capture process begins, ensuring the system works optimally.</p>

                <span className="esp-h2">Yes, There Are Challenges. But Let's Focus on the Possibilities</span>

                <p>The ESP market comes with these speed bumps:</p>

                <ul>
                  <li><span>High installation and maintenance costs</span></li>
                  <li><span>Technological complexity</span></li>
                  <li><span>Competition from baghouse filters</span></li>
                </ul>

                <p>However, these limitations still spark innovation by motivating manufacturers to think smarter and innovate. Currently, the emphasis is on consolidated ESPs, modular designs, and AI-driven automation, which fuel better, more innovative, and more accessible ESPs.</p>

                <span className="esp-h2">In Essence</span>

                <p>With rising technological innovations and a growing need for cleaner air, industries are investing in Electrostatic precipitators to lead the way into a new era of emission control.<br />
                If you are prepared to update your dust collection strategy, now is the time to perform.</p>

                <p><strong>Explore new-generation ESP solutions at Ador and stay up-to-date with regional regulations.</strong></p>

                <p>Ready to see cleaner air and clearer savings? <a href="/contact" className="esp-red-link">Contact us now!</a></p>

              </div>

              {/* ── Bottom row ── */}
              <div className="esp-bottom-row">
                <div className="esp-bottom-nav">
                  <a href="/news/transformer-bushings-types-importance" className="esp-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/next" className="esp-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="esp-share-icons">
                  <a href="#" className="esp-share-icon" aria-label="Facebook">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="#" className="esp-share-icon" aria-label="Twitter">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="#" className="esp-share-icon" aria-label="LinkedIn">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="esp-sidebar">

              {/* Recent Posts */}
              <div className="esp-sidebar-block">
                <p className="esp-sidebar-title">Recent Posts</p>
                <div className="esp-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="esp-recent-item">
                      <img src={post.img} alt={post.title} className="esp-recent-img" />
                      <div className="esp-recent-body">
                        <span className="esp-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="esp-sidebar-block">
                <p className="esp-sidebar-title">Social Media</p>
                <div className="esp-social-icons">
                  <a href="#" className="esp-social-icon" aria-label="YouTube">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="#" className="esp-social-icon" aria-label="LinkedIn">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}